/**
 * FixedIncomeCommand — Sprint 21.7.2 Domain Command Center.
 * Specialist home for rates / credit / duration. Backed by HEPHAESTUS.
 */
import { useEffect } from 'react';
import { Hammer } from 'lucide-react';
import CommandCenterLayout from '../../components/CommandCenter/CommandCenterLayout.jsx';
import { usePage } from '../../contexts/PageContext.jsx';

export default function FixedIncomeCommand() {
  const { setPage } = usePage();
  useEffect(() => { setPage('command-fixed-income'); }, []);
  return (
    <CommandCenterLayout
      domain="fixed-income"
      title="Fixed Income Command"
      icon={<Hammer className="w-5 h-5" />}
      subtitle="Rates · credit · duration · yield curve"
    />
  );
}
